import React from "react";
import styles from "./Facts.module.scss";
import { customSanitize } from "../../utils/customSanitize";
import { StaggerAnimation } from "@/components/Animation";
import { Modul_Fakten_Grid } from "@aleksundshantu/schirdewan-standard-types/acf-module";
import { FactsGridOptionsType } from "@/types/ModuleOptionsType";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";
import { Section } from "@/components/Section/Section";
import { Headline } from "@/components/Headline/Headline";

export type FactsModuleType = Modul_Fakten_Grid;

export type FactsElementType = {
  title: string;
  content: string;
};

interface FactsProps {
  data: FactsModuleType;
  factsGridOptions: FactsGridOptionsType;
}

const Facts = ({ data, factsGridOptions }: FactsProps) => {
  const {
    section_padding_class,
    section_margin_class,
    background_color_class,
    text_align_class,
    id,
    grid_columns,
    headline_text_align_class,
  } = data.layout;

  const { headline, headline_html_tag, elements, number_type } =
    data.facts_grid;
  const show_line = factsGridOptions?.show_line;
  const { show_border_radius, show_box_shadow, show_card_box } =
    factsGridOptions?.box || {
      show_border_radius: false,
      show_box_shadow: false,
      show_card_box: false,
    };
  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }

  return (
    <Section
      id={id}
      className={`facts ${background_color_class} ${section_padding_class} ${section_margin_class}`}
      disableColumns
    >
      <div className="columns is-multiline is-centered">
        {headline && (
          <div className="column is-12">
            <Headline
              headline={headline}
              headline_html_tag={headline_html_tag}
              extraClass={headline_text_align_class}
              disableAnimation
            />
          </div>
        )}

        <div className="column is-12">
          <StaggerAnimation
            animation="slide-up-no-opacity"
            staggerDelay={50}
            className={`columns is-multiline is-centered ${styles["facts-columns"]}  ${show_line ? styles["show-line"] : ""} ${show_line && grid_columns === "four-cols" ? styles["four-cols"] : ""}`}
          >
            {Array.isArray(elements) &&
              elements.map((element, key) => (
                <div
                  data-fontsize={number_type}
                  key={key}
                  className={`column is-10-tablet is-8-fullhd`}
                >
                  <div
                    className={`${styles["facts-element"]} ${text_align_class === "has-text-left" ? styles["align-left"] : ""} ${show_card_box && !show_line ? "is-box" : ""} ${show_border_radius && show_card_box ? "has-border-radius" : ""} ${show_box_shadow && show_card_box ? "has-box-shadow" : ""}`}
                  >
                    {element.title && (
                      <span
                        className={`facts-big ${styles["fact-title"]} is-clipped ${text_align_class === "has-text-centered" ? "has-text-centered" : ""}`}
                      >
                        {element.title}
                        {/* <RunningDigit
                          value={customSanitize(element.title).replace(
                            /<[^>]*>?/gm,
                            "",
                          )}
                        /> */}
                      </span>
                    )}
                    {element.content && (
                      <div
                        className={`facts-small ${text_align_class === "has-text-centered" ? "has-text-centered" : ""}`}
                        dangerouslySetInnerHTML={{
                          __html: customSanitize(element.content),
                        }}
                      />
                    )}
                    {element.textarea && (
                      <div
                        className={`${styles["content"]} ${text_align_class === "has-text-centered" ? "has-text-centered" : ""}`}
                        dangerouslySetInnerHTML={{
                          __html: customSanitize(element.textarea),
                        }}
                      />
                    )}
                  </div>
                </div>
              ))}
          </StaggerAnimation>
        </div>
      </div>
    </Section>
  );
};

export default Facts;
